/**
 * 메모리 최적화 관련 상수
 * @see docs/MEMORY_OPTIMIZATION_DESIGN.md
 */

/** Space 전환 시 Blob URL 상한 (XR 썸네일/프리뷰) */
export const MAX_BLOB_URLS = 8;

/**
 * WASM 메모리 기반 iframe 재마운트 임계치 (MB)
 * Unity WebGL의 WebAssembly.Memory.buffer.byteLength 기준.
 * performance.memory.usedJSHeapSize는 WASM LinearMemory를 포함하지 않으므로
 * iframe 내부 postMessage로 실제 WASM 힙 크기를 측정하여 판단한다.
 */
export const WASM_MEMORY_REMOUNT_THRESHOLD_MB = 700;

/** WASM 메모리 조회 postMessage 타임아웃 (ms) — 응답 없으면 fallback(전환 횟수) 사용 */
export const WASM_MEMORY_QUERY_TIMEOUT_MS = 750;

/**
 * WASM 메모리 조회 실패 시 fallback: N회 Space 전환마다 강제 remount.
 * WASM 메모리 조회 성공 시에는 임계치만으로 판단하므로 이 값은 무시된다.
 */
export const SPACE_SWITCH_COUNT_FORCE_REMOUNT = 3;

/**
 * Space 전환 시마다 iframe 재마운트
 * - true: 매번 재마운트 (모든 메모리 해제, 전환 2~5초 지연)
 * - false: WASM 메모리 임계치 또는 전환 횟수로 조건부 재마운트
 * @see docs/IMPROVEMENT_GOALS.md 1단계
 */
export const ALWAYS_REMOUNT_ON_SPACE_SWITCH = false;

/** viewrDataUpdated 디바운스 (ms) - 전송 빈도 감소로 직렬화 부하 완화 */
export const VIEWR_DATA_UPDATED_DEBOUNCE_MS = 200;

/** iframe 재마운트 시 unloadComplete 대기 타임아웃 (ms) */
export const UNLOAD_COMPLETE_TIMEOUT_MS = 3000;

/** iframe 재마운트 후 Unity 준비 대기 타임아웃 (ms) */
export const UNITY_READY_AFTER_REMOUNT_TIMEOUT_MS = 30000;

/** remount 후 ViewR 로드 시 modelLoadComplete 대기 타임아웃 (ms) */
export const MODEL_LOAD_AFTER_REMOUNT_TIMEOUT_MS = 60000;

/** 주기적 WASM 메모리 체크 임계치 (MB) - 이 값 초과 시 토스트 + iframe 재마운트 */
export const PERIODIC_CHECK_THRESHOLD_MB = 700;

/** 주기적 메모리 체크 간격 (ms) */
export const PERIODIC_CHECK_INTERVAL_MS = 5 * 60 * 1000;

/** Phase 3.2: Editor 내 대용량 쿼리(rawFiles, finalFiles 등) gcTime (ms) */
export const QUERY_GC_TIME_MS = 60 * 1000;

/** Space 전환 타임아웃 (ms) - remount 완료 후 Unity space_selected 응답 대기 최대치 (remount 자체는 prepareForSpaceSwitch 내부 타임아웃이 커버) */
export const SPACE_TRANSITION_TIMEOUT_MS = 10 * 1000;

/** merge_in_progress 에러 시 tool_selectSpace 재시도 대기 (ms) - Unity 자동 저장/병합 완료 대기 (저장 시간 고려 2000ms) */
export const SPACE_SELECT_RETRY_DELAY_MS = 2000;

/**
 * EDITOR 언마운트 시 Unity Quit 처리 대기 (ms)
 * sendUnityQuitRequest 후 iframe 제거 전 대기. Unity가 Quit 메시지를 처리하고
 * WebGL/WASM 리소스를 정리할 시간을 확보하여 메모리 누적을 완화한다.
 * 500ms: WebGL 컨텍스트 해제 및 WASM 메모리 반환이 완료될 시간 확보.
 */
export const UNLOAD_QUIT_DELAY_MS = 500;

/**
 * Save 완료 시 Snackbar 표시 여부
 * - true: "💾 Save complete!" Snackbar 표시 (파일 크기, 경로, Job ID 포함)
 * - false: Snackbar 숨김 (저장은 정상 완료되며, UI 알림만 비표시)
 * @see docs/SPACE_SWITCH_ISSUES_ANALYSIS.md §4
 */
export const SHOW_SAVE_COMPLETE_SNACKBAR = false;
